import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { BusinessSettingsForm } from '@/components/BusinessSettingsForm';
import { useBusinessNav } from '@/hooks/useBusinessNav';

export function BusinessSettings() {
  const { nav } = useBusinessNav();

  return (
    <div className="px-6 pt-6 pb-6">
      <div className="space-y-1 mb-8">
        <Button
          variant="ghost"
          size="sm"
          className="mb-2 -ml-2 text-muted-foreground"
          onClick={() => nav('/settings')}
        >
          <ArrowLeft className="mr-1 h-4 w-4" />
          Back to Settings
        </Button>
        <h1 className="text-2xl font-semibold tracking-tight">Business Information</h1>
        <p className="text-sm text-muted-foreground">
          Manage your business profile, logo, and industry.
        </p>
      </div>

      <BusinessSettingsForm />
    </div>
  );
}
